import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { firebaseAuth } from "../../config/firebase";
import { showSuccess, showError } from "../../utils/alerts";
import { Mail, RefreshCcw } from "lucide-react";
import AuthService from "../../services/Auth/auth.service";
import AuthLayout from "../../components/layout/AuthLayout";
import "./style.scss";

export default function EmailVerification() {
  const navigate = useNavigate();
  const [timer, setTimer] = useState(60);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const userEmail = firebaseAuth.currentUser?.email;

  const resendEmailVerification = async () => {
    const { message, type } = await AuthService.sendEmailVerificationFirebase();
    const alert = type === "success" ? showSuccess : showError;

    alert(message);
    setTimer(60);
    setIsButtonDisabled(true);
  };

  const formatTimer = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const remainingSeconds = timeInSeconds % 60;

    return `${minutes}m ${remainingSeconds}s`;
  };

  useEffect(() => {
    const interval = setInterval(async () => {
      const user = firebaseAuth.currentUser;

      if (!user) return;

      await user.reload();

      if (user.emailVerified) {
        clearInterval(interval);
        await AuthService.markEmailAsVerified(user.uid);
        showSuccess("E-mail verificado!");
        navigate("/");
      }
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (timer <= 0) {
      setIsButtonDisabled(false);
      return;
    }

    const counterTime = setTimeout(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(counterTime);
  }, [timer]);

  return (
    <AuthLayout
      panelTitle="Quase lá. Confirme que é você."
      panelSubtitle="Acesso seguro · LGPD compliant"
      panelDescription="A verificação de e-mail garante que o acesso à plataforma 121 Insights CX seja exclusivamente seu e em conformidade com as boas práticas de segurança e LGPD do Sistema Unimed."
    >
      <div className="auth__form">
        <div className="auth__icon-wrapper">
          <Mail size={34} />
        </div>
        <h1 className="verify-email__title">Verifique seu e-mail.</h1>

        <p className="verify-email__description">
          Enviamos um link de verificação para{" "}
          <span className="auth__highlight">{userEmail}</span>. Clique no link
          recebido para continuar. Caso não encontre, verifique a caixa de spam
          ou lixo eletrônico.
        </p>

        <button
          className="auth__submit-button"
          onClick={resendEmailVerification}
          disabled={isButtonDisabled}
        >
          <RefreshCcw size={14} />
          Reenviar e-mail {timer > 0 && `(${formatTimer(timer)})`}
        </button>
      </div>
    </AuthLayout>
  );
}
